import { Skeleton } from "@mui/material";
import { Box, Card, CardContent, Typography } from "../../../components";

export default function PainelAnaliseFiscalDocumentosModelo({ loading, resumoFiscal = {} }) {
  const modelosRaw = resumoFiscal.documentosPorModelo || resumoFiscal.documentosModelo || null;

  const modelos = modelosRaw && modelosRaw.length > 0
    ? modelosRaw.map((m) => ({
        name: m.name || m.label || `Modelo ${m.modelo || m.model || "?"}`,
        count: Number(m.count ?? m.qtd ?? m.quantidade ?? m.value ?? 0),
        color: m.color || m.colorHex || null,
      }))
    : [
        { name: "NF-e — modelo 55", count: Number(resumoFiscal.qtdNFe ?? 0), color: "#2e86ff" },
        { name: "NFC-e — modelo 65", count: Number(resumoFiscal.qtdNFCe ?? 0), color: "#1abc9c" },
      ];

  const total = modelos.reduce((s, m) => s + (m.count || 0), 0) || 1;

  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0" }}>
      <CardContent sx={{ p: 2 }}>
        <div>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Documentos por modelo
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Contagem por modelo de documento
          </Typography>
        </div>

        {loading ? (
          <Box sx={{ mt: 2 }}>
            {[1, 2].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                height={48}
                sx={{ my: 1, borderRadius: 1 }}
              />
            ))}
          </Box>
        ) : (
          <Box sx={{ mt: 2 }}>
            {modelos.map((m, idx) => {
              const percent = Math.round(((m.count || 0) / total) * 100);
              return (
                <Box key={m.name + idx} sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 0.5,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          background: m.color || "#1976d2",
                          display: "inline-block",
                          mr: 1,
                        }}
                      />
                      {m.name}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      {m.count} notas
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 10,
                      background: "#f1f5f9",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        width: `${percent}%`,
                        height: "100%",
                        background: m.color || "#1976d2",
                      }}
                    />
                  </Box>

                  <Typography
                    variant="caption"
                    sx={{ color: "text.secondary", display: "block", mt: 0.5 }}
                  >
                    {percent}% dos documentos enviados
                  </Typography>
                </Box>
              );
            })}
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
